import { useEffect, useState } from 'react'

import { bateriaExenta, pedirExencionBateria } from '@/lib/nativo/bateria'

import estilos from './AvisoBateria.module.css'

/**
 * Quitar el ahorro de batería.
 *
 * Solo aparece en la app nativa de Android y solo si el teléfono AÚN tiene esta
 * app dentro del ahorro de batería —el estado en que Android la suspende con la
 * pantalla apagada y deja de reportar ubicación y de sonar—. Una vez exenta,
 * desaparece: es una cosa que se hace una sola vez.
 *
 * Va junto al interruptor de avisos, en la pantalla de trabajo, por lo mismo:
 * el técnico no va a ir a buscar un ajuste; se le ofrece donde ya está.
 */
export function AvisoBateria() {
  // null = todavía no se sabe; true = ya exenta (no mostrar); false = mostrar.
  const [exenta, setExenta] = useState<boolean | null>(null)

  useEffect(() => {
    void bateriaExenta().then(setExenta)
  }, [])

  // Al volver de los ajustes del sistema, revisar de nuevo: si ya la concedió,
  // el aviso se va solo sin que tenga que recargar nada.
  useEffect(() => {
    const alVolver = () => {
      if (document.visibilityState === 'visible') void bateriaExenta().then(setExenta)
    }
    document.addEventListener('visibilitychange', alVolver)
    return () => document.removeEventListener('visibilitychange', alVolver)
  }, [])

  if (exenta === null || exenta) return null

  return (
    <div className={estilos.zona}>
      <div>
        <p className={estilos.titulo}>Quitar el ahorro de batería</p>
        <p className={estilos.texto}>
          Para que la ubicación y los avisos sigan funcionando con el teléfono guardado, hay que
          dejar esta app fuera del ahorro de batería. Es una sola vez.
        </p>
      </div>

      <button
        type="button"
        className={estilos.boton}
        onClick={() => void pedirExencionBateria()}
      >
        Quitarlo
      </button>
    </div>
  )
}
